export default "__VITE_ASSET__CU5Y9a1t__"